import React from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useLang } from '../i18n';

// Полный алфавит (урок 0 курса русского): буква, латиница, как звучит
export default function AlphabetTable({ rows }) {
  const { t } = useLang();
  if (!rows?.length) return null;
  return (
    <Box sx={{ my: 2 }}>
      <Typography variant="subtitle2" gutterBottom>{t('course.alphabet')}</Typography>
      <Table size="small" sx={{ '& td, & th': { px: 1, py: 0.5 } }}>
        <TableHead>
          <TableRow>
            <TableCell>{t('course.alphabet.letter')}</TableCell>
            <TableCell>{t('course.alphabet.latin')}</TableCell>
            <TableCell>{t('course.alphabet.sound')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map(([letter, latin, sound]) => (
            <TableRow key={letter}>
              <TableCell sx={{ fontSize: '1.15rem', fontWeight: 600, whiteSpace: 'nowrap' }}>{letter}</TableCell>
              <TableCell sx={{ whiteSpace: 'nowrap' }}><strong>{latin}</strong></TableCell>
              <TableCell><Typography variant="body2">{sound}</Typography></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
